import styled, { css } from 'styled-components';
import { StyledBackgroundProps } from './Background.type';

export const StyledBackground = styled.div<StyledBackgroundProps>`
  ${({ src, fixed }) => src
    && css`
      background: url(${src}) no-repeat;
      background-attachment: ${fixed ? 'fixed' : 'scroll'};
      background-position: center;
    `}
  ${({ theme }) => theme.down(theme.breakpoints.md)} {
    background: none;
  }
`;
